import { reportsApi } from 'Api/axios/reports-api';
import useEmployeesReportApi from 'Hooks/useEmployeesReportApi';
import useTranslation from 'Hooks/useTranslation';
import { useState } from 'react';
import type { EmployeeReportFilterI } from 'types';
import { downloadFile } from 'Utils/file-utils';

const useEmployeeReportPage = () => {
  const { t2 } = useTranslation('employees_reports');
  const [currentFilters, setCurrentFilters] = useState<EmployeeReportFilterI>({});

  const {
    data: employeesReportData,
    loading: employeesReportLoading,
    error: employeesReportError,
    fetchEmployeesReport,
  } = useEmployeesReportApi({ init: true });

  const handleSearch = (filters: EmployeeReportFilterI) => {
    setCurrentFilters(filters);
    fetchEmployeesReport(filters);
  };

  const handleExport = async () => {
    const response = await reportsApi.exportEmployees(currentFilters);

    if (response.data) {
      downloadFile(response.data, `empleados_reporte.xlsx`);
    }
  };

  return {
    employeesReportData,
    employeesReportLoading,
    employeesReportError,
    fetchEmployeesReport,
    t2,
    handleSearch,
    handleExport,
  };
};

export default useEmployeeReportPage;
